import React from "react";

function TitleMedium5() {
  return (
    <div className="roles-table-header">
      <div className="roles-col roles-col-email">Email</div>
      <div className="roles-col roles-col-name">User name</div>
      <div className="roles-col roles-col-role">User role</div>
      <div className="roles-col roles-col-phone">Phone number</div>
      <div className="roles-col roles-col-actions">Actions</div>
    </div>
  );
}

export default TitleMedium5;
